import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { responseObj } from '../../nest-model/nest-model';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs';
import { RequestCertificationDto, RequestbyIdCertificationDto } from '../dto/certification.dto';

@Injectable()
export class CertificationSf6Api {

  module: string = '';
  model: string = 'sf6s/certification';
  private readonly service: string = '';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello certification SF6 Provider');
  }
  
  public listing(formData: RequestCertificationDto): Observable<any> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "listing";
    const params: any = {};
    const urlParams: any = formData || {};
    const body: any = {};
    const contentType = 'json'

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }
  
  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  save(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "save";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  delete(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public historyById(formData: RequestbyIdCertificationDto): Observable<any> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "historyById";
    const params: any = {};
    const urlParams: any = formData || {};
    const body: any = {};
    const contentType = 'json'

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public updatePost(payload: any): Observable<any> {
    console.log('updatePost', payload)
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'updatePost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json'

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public checkCertification(payload: any): Observable<any> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'checkCertification';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json'

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  downloadPDFLetter() {
    const method: string = 'POST';
    const func: string = 'downloadPDFLetter';
    const urlParams: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/certification-sf6.ts